export const FAQArticles = [
    {
        title: "The Education Section doesn’t show on my profile",
        content: "The Education Section doesn’t show on my profile"
    },
    {
        title: "I can show my work profile on my profile but not my education",
        content: "I can show my work profile on my profile but not my education"
    },
    {
        title: "I can show my work profile on my profile but not my education",
        content: "I can show my work profile on my profile but not my education"
    },
    {
        title: "I can show my work profile on my profile but not my education",
        content: "I can show my work profile on my profile but not my education"
    },
];
